<template>
  <div>
    <!-- 头部 -->
    <div class="header">
      <h1 class="page-title">订单提醒</h1>
      <div class="pic">
        <div class="img">
          <span class="pic1"></span>
        </div>
        <div class="img">
          <span class="pic2"></span>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <el-card>
      <!-- 核对订单 -->
      <div class="box-card">
        <div class="text">
          <div class="t-top">
            <span>亲，请核对订单信息</span>
            <span class="time">2019年8月31日 08:24</span>
          </div>
          <div class="cont">
            <div class="cont-1">
              <img src="../../../assets/new/name.png" alt />
              <span>左手右手一个慢动作</span>
            </div>
            <div class="cont-2">
              <img src="../../../assets/new/phone.png" alt />
              <span>15838967854</span>
            </div>
            <div class="cont-3">
              <img src="../../../assets/new/adress.png" alt />
              <span>地址：</span>
              <span>河南省郑州市高新区瑞达广场木兰里2单元1002</span>
            </div>
          </div>
          <p>
            产品：
            <span>普通不干胶_90x54_模切_覆膜</span>
          </p>
        </div>
        <div class="smallicon">
          <span class="iconitem4" title="确认订单"></span>
          <span class="iconitem1" title="标记未读"></span>
          <span class="iconitem5" title="修改订单"></span>
          <span class="iconitem2" title="查看订单"></span>
          <span class="iconitem3" title="删除"></span>
        </div>
      </div>
      <!-- 验收提醒 -->
      <div class="box-card">
        <div class="text">
          <div class="t-top">
            <span>验收提醒</span>
            <span class="time">2019年8月31日 08:24</span>
          </div>
          <p>
            产品：
            <span>普通不干胶_90x54_模切_覆膜</span>
          </p>
          <p>收获时，确认无误再签收哦！宝贝没有问题麻烦亲给个5星好评，本店有奖励的哦</p>
        </div>
        <div class="smallicon">
          <span class="iconitem4" title="确认订单"></span>
          <span class="iconitem1" title="标记未读"></span>
          <span class="iconitem5" title="修改订单"></span>
          <span class="iconitem2" title="查看订单"></span>
          <span class="iconitem3" title="删除"></span>
        </div>
      </div>
      <!-- 未付款 -->
      <div class="box-card">
        <div class="text">
          <div class="t-top">
            <span>亲，您有一个订单尚未付款</span>
            <span class="time">2019年8月31日 08:24</span>
          </div>
          <p>亲，您有一个订单尚未付款，赶快去下单吧！</p>
        </div>
        <div class="smallicon">
          <span class="iconitem1" title="标记未读"></span>
          <span class="iconitem2" title="查看订单"></span>
          <span class="iconitem3" title="删除"></span>
          <!-- 标注 -->
        </div>
      </div>
      <!-- 分页 -->
      <el-pagination background small layout="prev, pager, next" :total="40"></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  created() {
    if(!window.localStorage.getItem('token')){
      this.$router.replace('/login')
      return
    }
    this.getYue()
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    }
  }
}
</script>

<style lang="less" scoped>
.el-pagination {
  text-align: center;
}
.header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  .page-title {
    font-size: 24px;
  }
  .pic {
    display: flex;
    .img {
      width: 42px;
      height: 42px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 24px;
      span {
        width: 22px;
        height: 22px;
        display: block;
      }
      .pic1 {
        background: url('../../../assets/new/xinxi.png') no-repeat;
        background-size: 100%;
      }
      .pic2 {
        background: url('../../../assets/new/saochu.png') no-repeat;
        background-size: 100%;
      }
      .pic1:hover {
        background: url('../../../assets/new/selxinxi.png') no-repeat;
        background-size: 100%;
      }
      .pic2:hover {
        background: url('../../../assets/new/selsaochu.png') no-repeat;
        background-size: 100%;
      }
    }
  }
}
.box-card {
  position: relative;
  width: 98%;
  height: 161px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border-left: 8px solid rgb(223, 223, 223);
  margin-bottom: 16px;
  .text {
    padding: 0 32px;
    box-sizing: border-box;
    .t-top {
      display: flex;
      justify-content: space-between;
      span {
        display: block;
        font-size: 16px;
        margin-top: 16px;
        line-height: 26px;
        font-weight: 500;
        color: rgba(89, 89, 89, 1);
      }
      .time {
        font-size: 10px;
        color: rgba(191, 191, 191, 1);
        font-weight: 400;
      }
    }
    .cont {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: rgba(140, 140, 140, 1);
      display: flex;
      margin-top: 10px;
      .cont-1 {
        margin-right: 80px;
        img {
          width: 12px;
          height: 14px;
          margin-right: 6px;
        }
      }
      .cont-2 {
        margin-right: 103px;
        img {
          width: 17px;
          height: 14px;
          margin-right: 6px;
        }
      }
      .cont-3 {
        img {
          width: 11px;
          height: 14px;
          margin-right: 6px;
        }
      }
    }
    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: rgba(140, 140, 140, 1);
      margin-top: 10px;
    }
  }
  .smallicon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 40px;
    position: absolute;
    bottom: 0px;
    span {
      display: block;
      margin-right: 21px;
    }
    .iconitem1 {
      width: 18px;
      height: 18px;
      background: url('../../../assets/new/nosee.png') no-repeat;
      background-size: 100%;
    }
    .iconitem2 {
      width: 17px;
      height: 18px;
      background: url('../../../assets/new/see.png') no-repeat;
      background-size: 100%;
    }
    .iconitem3 {
      width: 15px;
      height: 18px;
      background: url('../../../assets/new/delete.png') no-repeat;
      background-size: 100%;
    }
    .iconitem4 {
      width: 18px;
      height: 18px;
      background: url('../../../assets/new/confirm.png') no-repeat;
      background-size: 100%;
    }
    .iconitem5 {
      width: 17px;
      height: 18px;
      background: url('../../../assets/new/modify.png') no-repeat;
      background-size: 100%;
    }
    .iconitem1:hover {
      background: url('../../../assets/new/selnosee.png') no-repeat;
      background-size: 100%;
      cursor: pointer;
    }
    .iconitem2:hover {
      background: url('../../../assets/new/selsee.png') no-repeat;
      background-size: 100%;
      cursor: pointer;
    }
    .iconitem3:hover {
      background: url('../../../assets/new/seldele.png') no-repeat;
      background-size: 100%;
      cursor: pointer;
    }
    .iconitem4:hover {
      background: url('../../../assets/new/selconfirm.png') no-repeat;
      background-size: 100%;
      cursor: pointer;
    }
    .iconitem5:hover {
      background: url('../../../assets/new/selmodify.png') no-repeat;
      background-size: 100%;
      cursor: pointer;
    }
  }
}
.box-card:hover {
  box-shadow: 0px 0px 4px rgb(250, 173, 20);
  border-left: 8px solid rgb(250, 173, 20);
}
</style>